import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL — permanently redirects to keyword-first slug.
export const Route = createFileRoute("/westminster-web-design")({
  beforeLoad: () => {
    throw redirect({
      to: "/web-design-westminster-colorado",
      statusCode: 301,
    });
  },
});
